/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import CommonProgressBar from '../../../shared/CommonProgressBar/CommonProgressBar';
import { IAggregationData } from '../../../shared/ProgressBar/IProgressBarWidget';
interface IUtilitySiteMeterProps extends IAggregationData {
  currencyconverter: string;
}
const UtilityActualCostColumnComponent = (props: IUtilitySiteMeterProps) => {
  const {
    currencyconverter,
    actual,
    previousPeriod,
    savings,
    savingsPercentage,
    progessBarRelativeWidth
  } = props;
  const progressBarProps = {
    actual,
    previousPeriod,
    savings,
    savingsPercentage,
    progessBarRelativeWidth
  };
  return (
    <span className="emaas-carbondetail-category-meterdata">
      <span className="score-category-percent">
        <div className="measurementunit">{currencyconverter}</div>
      </span>
      <span className="score-category-progress">
        <CommonProgressBar {...progressBarProps} />
      </span>
    </span>
  );
};

export default UtilityActualCostColumnComponent;
